<svg width="100%" height="100%" viewBox="0 0 32 32"
	><path
		fill="currentColor"
		d="m31 16l-7 7l-1.41-1.41L28.17 16l-5.58-5.59L24 9l7 7zM1 16l7-7l1.41 1.41L3.83 16l5.58 5.59L8 23l-7-7zm11.42 9.484L17.64 6l1.932.517L14.352 26z"
	/>
</svg>
